
namespace TabAurous.Retail {

    @Serenity.Decorators.registerClass()
    export class POSOrderGrid extends _Ext.GridBase<POSOrderRow, any> {
        protected getColumnsKey() { return 'Retail.Order'; }
        protected getDialogType() { return POSOrderDialog; }
        protected getIdProperty() { return POSOrderRow.idProperty; }
        protected getInsertPermission() { return POSOrderRow.insertPermission; }
        protected getLocalTextPrefix() { return POSOrderRow.localTextPrefix; }
        protected getService() { return POSOrderService.baseUrl; } 
        private autoSize;
        private myToolDropdownButton: J.ToolDropdownButton;

        constructor(container: JQuery, options) {
            super(container, options);

        }
        protected onClick(e: JQueryEventObject, row: number, cell: number) {            
            var item = this.itemAt(row);
           // OrderItemsEditor.baseitemcheck = item.BaseItemTypeId;
            super.onClick(e, row, cell);            
        }
        protected addButtonClick() {
            
            let now = new Date();

            var voucher = FormatHelper.GetVoucherNo(47);

            var userdefinition = Q.Authorization.userDefinition;
            this.editItem(<POSOrderRow>{
                VoucherNo: voucher,
                Line_No: 0,
                VoucherTypeId: 47,
                CompanyId: userdefinition.CompanyId,
                FinancialYearId: userdefinition.FinancialYearId,
                UserId: userdefinition.UserId,
                CurrencyId: userdefinition.CurrencyId,
                TransDate: now.toDateString()                       
            });
        }
        protected createSlickGrid(): Slick.Grid {
            let grid = super.createSlickGrid();
            this.autoSize = new Slick.AutoColumnSize();
            grid.registerPlugin(this.autoSize);


            return grid;
        } 
        protected markupReady() {
            super.markupReady();
            if (this.autoSize != null) {
                this.autoSize.resizeAllColumns();
            }
        }
    }
}
